import React, { useState } from "react";
import "./App.css";
import background from "./images/background.jpg";
import bird from "./images/bird.jpg" 

const API_KEY = "53e3e932177124fb982f632e7d39e13d";

function App() {
  const [city, setCity] = useState("");
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState("");

  const fetchWeather = async () => {
    if (!city) return;

    try {
      setError("");
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&lang=th&appid=${API_KEY}`;
      const res = await fetch(url);
      const data = await res.json();

      if (data.cod !== 200) {
        setError("ไม่พบเมืองนี้ ลองใหม่อีกครั้ง");
        setWeather(null);
        return;
      }
      setWeather(data);
    } catch (err) {
      setError("เกิดข้อผิดพลาดในการดึงข้อมูล");
      setWeather(null);
    }
  };

  return (
    <div className="container">
      <div
        className="wrap"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative", // ให้ bird อยู่ภายใน
          overflow: "hidden",   // ป้องกันนกบินออกนอกกล่อง
        }}
      >
        <h1 className="title">🌤️ Weather App</h1>
        <p className="subtitle">พิมพ์ชื่อเมืองเพื่อดูสภาพอากาศตอนนี้</p>

        <div className="search-box">
          <input
            type="text"
            placeholder="เช่น Bangkok"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
          <button onClick={fetchWeather}>ค้นหา</button>
        </div>

        {error && <p className="error">{error}</p>}

        {weather && (
          <div className="card fade-in">
            <h2>{weather.name}</h2>
            <p className="desc">{weather.weather[0].description}</p>
            <div className="temp">{Math.round(weather.main.temp)}°C</div>
            <div className="info">
              💧 {weather.main.humidity}% | 🌬️ {weather.wind.speed} m/s
            </div>
          </div>
        )}

       {/* น้องเครื่องบิน */}
        <img src={bird} alt="bird" className="bird" />
      </div>
    </div>
  );
}

export default App;
